import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
    ExecRegExp,
    truncateString,
    getOperator,
    returnEmpty,
    encodeUtf8,
    checkBoolean,
    verifyCustomEditorList,
    findItem,
    truncString,
} from '@core/_utils/tools.utils';
import { format, formatDateInt } from '@core/_utils/date.utils';
import { RegExpIsFloat, BaseType, actionMail } from '@documalis/_const/const';
import { DynIndexService } from './dynindex.service';
import { VariableListService } from './variablelist.service';
import { IndexedDbService } from './indexeddb.service';

@Injectable()
export class EditorService {
    private isLoading = false;
    public variableStorage: any;
    public customEditorList: any;
    public varListSave: string = '';
    public bskVarListDefault: Array<any>;
    private mailAction: Array<any>;

    constructor(public dynIndex: DynIndexService, public variableListService: VariableListService,
        private translate: TranslateService, private indexedDbService: IndexedDbService) {
        this.bskVarListDefault = new Array();
        this.mailAction = new Array();
        this.setMailAction();
    }

    private getLocalStorage() {
        if (this.isLoading) {
            return;
        }
        this.variableStorage = this.indexedDbService.variableStorage;
        this.isLoading = true;
    }

    private setMailAction() {
        actionMail.map(item => {
            this.mailAction.push({
                displayValue: this.translate.instant('Mail_'+item.value),
                retCode: item.value
            });
        });
    }

    public setCustomEditorList(aEditorList) {
        this.customEditorList = aEditorList;
        this.variableListService.setCustomEditorList(aEditorList);
        this.dynIndex.setCustomEditorList(aEditorList);
    }

    public setMode(aMode) {
        this.variableListService.setMode(aMode);
    }

    public setIsLoading(aValue) {
        this.isLoading = aValue;
        this.variableListService.setIsLoading(aValue);
    }

    public setBskVarListDef(aVarList) {
        let parseList: any;
        this.bskVarListDefault = [];
        if (aVarList !== undefined) {
            if (!Array.isArray(aVarList.VariableList)) {
                this.bskVarListDefault = JSON.parse(JSON.stringify(this.variableListService.formatVarArray(aVarList)));
                parseList = {
                    VariableList: {
                        Variable: this.bskVarListDefault,
                    },
                };
                this.bskVarListDefault = this.variableListService.execParse(parseList).VariableList.Variable;
            }
        }
    }

    public verifyPattern(aVarlist) {
        let wMess = '';
        aVarlist.forEach((item) => {
            if (item.value !== '' && item.value !== null) {
                switch (item.type) {
                    case 'EditMask': {
                        if (!ExecRegExp(item.pattern.regExpr, item.pattern.flags, item.value)) {
                            wMess = wMess + item.Label + ', ';
                        }
                        break;
                    }
                    case 'Double': {
                        if (!ExecRegExp(RegExpIsFloat, '', item.value)) {
                            wMess = wMess + item.Label + ', ';
                        }
                        break;
                    }
                }
            }
        });
        wMess = truncateString(wMess);
        return wMess;
    }

    public verifyRequiredIndex(aVarlist) {
        let wMess = '';
        aVarlist.forEach((item) => {
            if (item.Required === true && item.name !== '&SeparationLine' && this.requiredIndex(item) === false) {
                wMess = wMess + item.Label + ', ';
            }
        });
        wMess = truncateString(wMess);
        return wMess;
    }

    private requiredIndex(aVariable) {
        let wRes = true;
        let wValue = '';
        wValue = this.getValueFromType(aVariable, true);
        wValue = wValue.trim();
        if (wValue === '') {
            wRes = false;
        }
        return wRes;
    }

    private initResult() {
        return {
            defaultValue: '',
            value: '',
            valueCombo: '',
        };
    }

    private initValue() {
        return {
            displayValue: '',
            retCode: '',
        };
    }

    // Maj variable / source
    private updateBasketIndex(aIndex, aItembsk, aSourceList) {
        let wResult;// = this.initResult();

        if (aIndex !== -1) {
            wResult = this.updateBasketIndexFind(aIndex, aItembsk, aSourceList);
        } else {
            wResult = this.getValueNotFound(aItembsk);
        }

        aItembsk.valueCombo = wResult.valueCombo;
        if (aItembsk.type === 'DynamicIndex') {
            aItembsk.value.displayValue = wResult.defaultValue;
            if (wResult.value.retCode !== null) {
                aItembsk.value.retCode = wResult.defaultValue;
            }
            aItembsk.DefaultValue = '';
        } else {
            if (aItembsk.Editable === true) {
                if (aItembsk.type === 'ListDB') {
                    aItembsk.value = wResult.value;
                    aItembsk.valueCombo = wResult.defaultValue;
                } else {
                    aItembsk.value.displayValue = wResult.defaultValue;
                    aItembsk.value.retCode = wResult.defaultValue;
                }
            } else {
                aItembsk.value = wResult.value;
            }
            aItembsk.DefaultValue = wResult.defaultValue;
        }
    }

    private getValueNotFound(aItembsk) {
        let wtype;
        let wDefault;
        let wRes;
        let wResult = this.initResult();
        // Type éditeur inconnu : recherche du type
        if (BaseType.indexOf(aItembsk.type) !== -1) {
            wResult = this.setValueResult(aItembsk, aItembsk.DefaultValue);
        } else {
            wtype = this.getTypeFromVarEditorList(aItembsk.name, aItembsk.DefaultValue, false);
            wResult = this.setValueResult(wtype, wtype.default);
        }
        // Récup des valeurs par défault si présentent dans variables basket
        let wFind = this.bskVarListDefault.find((item) => {
            return item.Name.toUpperCase() === aItembsk.name.toUpperCase();
        });
        if (wFind !== undefined) {
            wDefault = wFind.DefaultValue;
            switch (aItembsk.type) {
                case 'ComboCustom':
                case 'ListDB':
                case 'ListUsers':
                case 'ListGroups': {
                    wRes = this.getComboValueKey(wDefault, aItembsk.comboValue, 'displayValue');
                    wResult.value = wRes;
                    break;
                }
                case 'Combo': {
                    wRes = this.getComboValueKey(wDefault, aItembsk.comboValue, 'retCode');
                    wResult.value = wRes;
                    break;
                }
                case 'Boolean': {
                    wRes = checkBoolean(wDefault, true);
                    wResult.value = wRes;
                    wDefault = wResult.value;
                    break;
                }
                default: {
                    wResult.value = wDefault;
                    break;
                }
            }
            wResult.defaultValue = wDefault;
            wResult.valueCombo = wDefault;
        }
        return wResult;
    }

    private setValueResult(aData, aDefaultValue) {
        let wResult = this.initResult();
        if (aData.valueCombo !== undefined) {
            wResult.valueCombo = aData.valueCombo;
            wResult.value = aData.value;
            wResult.defaultValue = aData.value !== null && aData.value !== undefined ? aData.value.displayValue : aDefaultValue;
        } else {
            wResult.value = aData.value;
            wResult.defaultValue = aDefaultValue;
        }
        return wResult;
    }

    private updateBasketIndexFind(aIndex, aItembsk, aSourceList) {
        let wResult = this.initResult();
        let wValue;
        switch (aItembsk.type) {
            case 'Date':
            case 'DateTime': {
                wResult = this.setDateBskValue(aSourceList[aIndex].value);
                break;
            }
            case 'DynamicIndex':
            // case 'ListDB':
            case 'ListGroups':
            case 'ListUsers':            
            case 'ComboCustom': {
                wResult = this.getComboValueDisplay(aSourceList[aIndex].value, aItembsk);
                break;
            }
            case 'Boolean': {
                wResult = this.setBooleanValue(aSourceList, aIndex);
                wValue = checkBoolean(wResult.value, true);
                wResult.value = wValue;
                break;
            }
            case 'ListDB':
            case 'Combo': {
                if (aItembsk.Editable === true) {
                    wResult = this.getEditableValue(aSourceList, aIndex);
                } else {
                    wResult = this.getComboValueDisplay(aSourceList[aIndex].value, aItembsk);
                }
                break;
            }
            default:
                wResult = this.setValue(aSourceList, aIndex);
                break;
        }
        return wResult;
    }

    private getVarListForUpdate() {
        let wVarList = new Array();
        wVarList = [];
        for (let i = 0; i < this.dynIndex.varListAll.length; i++) {
            if (this.dynIndex.varListAll[i].isActiv === true && this.dynIndex.varListAll[i] !== 'separator') {
                var item = this.dynIndex.varListAll[i];
                wVarList.push(item);
            }
        }
        return wVarList;
    }

    private getEditableValue(aSourceList, aIndex) {
        let wResult = this.initResult();
        wResult = this.setValue(aSourceList, aIndex);
        wResult.defaultValue = wResult.value;
        return wResult;
    }

    public getComboValueKey(aValue, aOptionList, aName) {
        return this.variableListService.getComboValueKey(aValue, aOptionList, aName);
    }

    private getComboValueDisplay(aValue, aItembsk) {
        let wResult = this.initResult();
        let wValue;
        wValue = this.getComboValueKey(aValue, aItembsk.comboValue, 'retCode');
        wResult.defaultValue = wValue.displayValue;
        wResult.value = wValue;
        return wResult;
    }
    private setBooleanValue(aSourceList, aIndex) {
        let wResult = this.initResult();
        if (aSourceList[aIndex].value === '') {
            wResult.defaultValue = null;
            wResult.value = null;
        } else {
            wResult.defaultValue = aSourceList[aIndex].value;
            wResult.value = aSourceList[aIndex].value;
        }
        return wResult;
    }

    private setValue(aSourceList, aIndex) {
        let wResult = this.initResult();
        wResult.valueCombo = aSourceList[aIndex].value;
        wResult.value = aSourceList[aIndex].value;
        return wResult;
    }

    private setDateBskValue(aValue) {
        let wResult = this.initResult();
        let wDefaultValue;
        let wValue;
        if (aValue !== '') {
            wDefaultValue = format(new Date(aValue));
            wValue = new Date(wDefaultValue);
            wResult.defaultValue = wDefaultValue;
            wResult.value = wValue;
        } else {
            wResult.defaultValue = null;
        }
        return wResult;
    }

    public upateListVariable(adata) {
        let wdata: any = [];
        let wRes: any;

        adata.map((item) => {
            wRes = this.getValFromType(item);
            wdata.push({
                name: item.name,
                Label: item.Label,
                type: item.type,
                DefaultValue: wRes.DefaultValue,
                comboValue: item.comboValue,
                Required: item.Required,
                system: item.system,
                value: wRes.Value,
                visible: item.visible,
                operator: getOperator(item.operator),
                pattern: item.pattern,
                Editable: item.Editable,
                valueCombo: wRes.ValueCombo,
                disabled: item.disabled,
                multiSelectMode: item.multiSelectMode,
                svgComboValue: item.svgComboValue
            });
        });
        return wdata;
    }

    private getValFromType(aItem) {
        let wDefaultValue: any;
        let wValue: any;
        let wValueCombo: any;

        switch (aItem.type) {
            case 'ListDB':
            case 'ListGroups':
            case 'ListUsers':
            case 'Combo':
            case 'ComboCustom': {
                wDefaultValue = this.getValueFromTyp(aItem).displayValue;
                wValue = this.getValueFromTyp(aItem);
                wValueCombo = wValue;
                break;
            }
            case 'DateTime': {
                wDefaultValue = this.getDate(aItem);
                wValue = this.getValue_default(aItem);
                wValueCombo = wValue;
                break;
            }

            default: {
                wDefaultValue = this.getValue_default(aItem);
                wValue = wDefaultValue;
                wValueCombo = wValue;
                break;
            }
        }
        return {
            DefaultValue: wDefaultValue,
            Value: wValue,
            ValueCombo: wValueCombo,
        };
    }

    public addDefaultDisplay(adata) {
        return adata.filter((item) => {
            return item.displaydefault === 1;
        });
    }

    // Paramètre aFromReq : en provenance d'une requête
    // Donc possible changement de l'éditeur en multiselect fonction de l'opérateur et du type d'éditeur
    public updateVariable(data, aFromReq = false) {
        // console.log(data);
        let wResult: any;
        data.forEach((item) => {
            item.visible = this.getVisible(item);
            item.value = this.updateValue(item);
            if (item.Editable === true) {
                if (item.value.displayValue !== undefined) {
                    item.valueCombo = item.value.displayValue;
                } else {
                    item.valueCombo = item.value;
                }
            }
            if (item.name === '&bsk_mailaction') {
                item.comboValue = this.getMailAction();
                item.value = {
                    displayValue: item.DefaultValue,
                    retCode: findItem(this.mailAction, item.DefaultValue, 'displayValue')
                }
            }
            // Permet de trouver le type : au premier accès,
            // si le type n'est pas connu, il est cherché
            // aux accès suivant il est donc connu
            // possibe de vérifier si le type est connu en se basant sur le tableau baseType
            if (item.value === null && item.type !== 'Boolean' && item.type !== 'InputCurrency' && item.type !== 'InputNumber') {
                wResult = this.findTypeFromType(item.type, item.DefaultValue, false);
                item.value = wResult.value;
                item.type = wResult.type;
                item.comboValue = wResult.option;
                item.pattern = wResult.pattern;
                item.Editable = wResult.Editable;
                item.valueCombo = wResult.valueCombo;
                item.disabled = wResult.disabled;
            }
            this.initMultiSelect(aFromReq, item);
        });
    }
    
    // Principe : si on a une combo et un opérateur in not in, on change le type d'éditeur en multiselect
    // Au 1er click, il est indéfini
    private initMultiSelect(aFromReq, aItem) {
        if (aFromReq === true) {
            if (aItem.multiSelectMode === undefined) {
                aItem.multiSelectMode = false;
                aItem.svgComboValue = [];
                if ((aItem.operator === 4 || aItem.operator === 5) && aItem.type !== 'TextArea' && aItem.Editable === false) {
                    aItem.multiSelectMode = true;
                    this.setMultiSelect(aItem);
                    aItem.svgComboValue = JSON.parse(JSON.stringify(aItem.comboValue));
                }
            } else {
                if (aItem.multiSelectMode === true) {
                    this.setMultiSelect(aItem);
                    aItem.comboValue = JSON.parse(JSON.stringify(aItem.svgComboValue));
                }
            }
        }
    }

    private setMultiSelect(aItem) {
        aItem.type = 'MultiSelect';
        aItem.value = [];        
    }

    private updateValue(aItem) {
        var fn;
        const type = {
            DynamicIndex: this.getNext,
            separator: this.getNext,
            EditMask: this.getNext,
            ListGroups: this.getNext,
            ListUsers: this.getNext,
            ListDB: this.getNext,
            Combo: this.getComboEditable,
            ComboCustom: this.getNext,
            String: this.getNext,
            TextArea: this.getNext,
            Integer: this.getNext,
            Double: this.getNext,
            Boolean: this.getBooleanValue,
            DateTime: this.getDateValue,
            default: this.getDefaultValue,
        };

        if (type[aItem.type]) {
            fn = type[aItem.type](aItem);
        } else {
            fn = type['default'](aItem);
        }
        return fn;
    }

    private getNext(aItem) {
        if (aItem.value !== undefined) {
            return aItem.value;
        } else {
            return '';
        }
    }

    private getComboEditable(aItem) {
        let wValue = {
            displayValue: '',
            retCode: '',
        };
        if (aItem.Editable === true) {
            if (aItem.value === undefined) {
                wValue.displayValue = aItem.DefaultValue;
                wValue.retCode = aItem.DefaultValue;
                return wValue;
            } else {
                return aItem.value;
            }
        } else {
            if (aItem.value !== undefined) {
                return aItem.value;
            } else {
                return '';
            }
        }
    }

    private getDefaultValue(aItem) {
        return null;
    }

    private getMailAction() {
        let wArray = [];
        for (let wIndex = 0; wIndex < this.mailAction.length; wIndex++) {
            wArray.push(this.mailAction[wIndex]);
        }
        return wArray;
    }

    private getVisible(aItem) {
        let wRes = 1;
        if (aItem.visible !== undefined) {
            wRes = aItem.visible;
        }
        if (aItem.system !== undefined) {
            if (aItem.system === 'true') {
                wRes = 0;
            }
        }
        return wRes;
    }

    private getBooleanValue(aItem) {
        let wRes;
        wRes = checkBoolean(aItem.DefaultValue, true);
        return wRes;
    }

    private getDateValue(aItem) {
        let wdate;
        if (aItem.DefaultValue !== '' && aItem.DefaultValue !== null) {
            wdate = new Date(aItem.DefaultValue);
        } else {
            wdate = '';
        }
        return wdate;
    }

    public setCurrentValue(aValue, index) {
        this.dynIndex.setCurrentValue(aValue, index);
    }

    public getChangeDyn() {
        return this.dynIndex.getChangeDyn();
    }

    public setChangeDyn(aValue) {
        this.dynIndex.setChangeDyn(aValue);
    }

    public setValueForUpdate(aCurrentVarList) {
        let wVarList = new Array();
        wVarList = [];
        if (this.getChangeDyn() === true) {
            wVarList = this.getVarListForUpdate();
        } else {
            wVarList = this.searchValueForUpdate(aCurrentVarList);
        }
        return wVarList;
    }

    private searchValueForUpdate(aCurrentVarList) {
        let wVarList = new Array();
        let wValue: any;
        wVarList = this.getVarListForUpdate();
        for (let i = 0; i < wVarList.length; i++) {
            if (wVarList[i].type !== 'DynamicIndex') {
                wValue = this.getValueFromRefIndex(aCurrentVarList, wVarList[i].refIndex);
                if (wValue.found === true) {
                    wVarList[i].value = wValue.value;
                    wVarList[i].multiSelectMode = wValue.multiSelectMode;
                    wVarList[i].svgComboValue = wValue.svgComboValue;
                    if (wVarList[i].type === 'Combo' || wVarList[i].type === 'ListDB') {
                        if (wVarList[i].Editable === true) {
                            if (wValue.value.retCode) {
                                wVarList[i].valueCombo = wValue.value.retCode;
                            } else {
                                wVarList[i].valueCombo = wValue.value;
                            }
                        }
                    }
                }
            }
        }
        return wVarList;
    }

    private getValueFromRefIndex(aCurrentVarList, aRefIndex) {
        let wValue = '';
        let wFound = false;
        let wMulti = false;
        let wSvgComboValue = [];
        for (let i = 0; i < aCurrentVarList.length; i++) {
            if (aCurrentVarList[i].refIndex === aRefIndex) {
                wValue = aCurrentVarList[i].value;
                if (aCurrentVarList[i].multiSelectMode !== undefined) {
                    wMulti = aCurrentVarList[i].multiSelectMode;
                    wSvgComboValue = aCurrentVarList[i].svgComboValue;
                }
                wFound = true;
                break;
            }
        }
        return {
            found: wFound,
            value: wValue,
            multiSelectMode: wMulti,
            svgComboValue: wSvgComboValue,
        };
    }

    // Changement d'index dynamique
    public changeDynIndex(aVarList, item, index) {
        let wVarList = new Array();
        wVarList = [];
        this.dynIndex.setCustomEditorList(this.customEditorList);
        wVarList = this.dynIndex.changeDynIndex(aVarList, item, index);
        this.updateVariable(wVarList);
        this.varListSave = JSON.stringify(wVarList);
        return wVarList;
    }

    public setVariableTransfert(aActionGroup, aVariableListTransfert, aDocIndex) {
        if (aActionGroup) {
            return JSON.parse(JSON.stringify(this.prepareListVar(aVariableListTransfert, [])));
        } else {
            return JSON.parse(JSON.stringify(this.prepareListVar(aVariableListTransfert, aDocIndex)));
        }
    }

    public prepareListVar(aBskVariable, aDocIndex) {
        // console.log('prepareListVar', aBskVariable);
        // console.log('prepareListVar aDocIndex', aDocIndex);
        let wList;
        let Variable = new Array();
        let wItem: any;
        Variable = [];
        for (let i = 0; i < aBskVariable.length; i++) {
            wItem = new Object();
            wItem.name = aBskVariable[i].name;
            wItem.DefaultValue = aBskVariable[i].DefaultValue;
            wItem.Forced = aBskVariable[i].Forced;
            wItem.Hidden = aBskVariable[i].hidden;
            wItem.Label = aBskVariable[i].Label;
            wItem.Name = aBskVariable[i].name;
            wItem.ReadOnly = aBskVariable[i].ReadOnly;
            wItem.Required = aBskVariable[i].Required;
            if (aBskVariable[i].type === 'DynamicIndex') {
                wItem.Type = aBskVariable[i].dynName;
            } else {
                wItem.Type = aBskVariable[i].type;
            }
            wItem.EditorName = aBskVariable[i].EditorName;
            wItem.value = aBskVariable[i].value;
            wItem.childPath = aBskVariable[i].childPath;
            wItem.disabled = aBskVariable[i].disabled;
            if (aBskVariable[i].ReadOnly === true) {
                wItem.Editable = false;
            } else {
                wItem.Editable = aBskVariable[i].Editable;
            }
            wItem.isActiv = aBskVariable[i].isActiv;
            wItem.parent = aBskVariable[i].parent;
            wItem.path = aBskVariable[i].path;
            wItem.system = aBskVariable[i].system;
            Variable.push(wItem);
        }
        wList = {
            VariableList: {
                Variable,
            },
        };
        return this.updateVarList(wList, aDocIndex);
    }

    private updateVarList(aData, aDocIndex) {
        let varList = new Array();
        this.dynIndex.reset();
        varList = [];
        this.variableListService.loadVariableList(
            this.dynIndex.varListAll,
            this.variableListService.formatVarArray(aData),
            '',
            '',
            true
        );
        this.updateBasketIndexList(aDocIndex, this.dynIndex.varListAll);
        this.dynIndex.activateAll();
        varList = this.dynIndex.loadActivField();
        return varList;
    }

    public updateBasketIndexList(aSourceList, aTargetList) {
        let windex = -1;
        aTargetList.map((itembsk) => {
            if (itembsk.type !== 'separator') {
                windex = aSourceList.findIndex((item) => item.Name.toUpperCase() === itembsk.name.toUpperCase());
                this.updateBasketIndex(windex, itembsk, aSourceList);
            }
        });
    }

    public updateBasketIndexListParse(aSourceList, aTargetList) {
        let wBskVariableList = [];
        let windex = -1;
        wBskVariableList = aSourceList.filter((item) => {
            if (item.value.substring(0, 2) === '<<') {
                item.value = this.variableListService.parseService.execParse(item.value);
                item.DefaultValue = item.value;
                return item;
            }
        });
        aTargetList.map((itembsk) => {
            if (itembsk.type !== 'separator') {
                windex = wBskVariableList.findIndex((item) => item.Name.toUpperCase() === itembsk.name.toUpperCase());
                if (windex !== -1) {
                    this.updateBasketIndex(windex, itembsk, wBskVariableList);
                }
            }
        });
    }

    // Lecture des variables de la bannette
    public formatVarList(aData) {
        let varList = new Array();
        this.dynIndex.reset();
        varList = [];
        if (aData !== undefined) {
            if (!Array.isArray(aData.VariableList)) {
                this.variableListService.loadVariableList(
                    this.dynIndex.varListAll,
                    this.variableListService.formatVarArray(aData),
                    '',
                    '',
                    true
                );
                this.dynIndex.activateAll();
                varList = this.dynIndex.loadActivField();
                return varList;
            }
        }
    }

    public formatVarListSearch(aData) {
        let varList = new Array();
        this.dynIndex.reset();
        varList = [];
        this.variableListService.loadVariableList(this.dynIndex.varListAll, aData, '', '', true);
        this.dynIndex.activateAll();
        varList = this.dynIndex.loadActivField();
        return varList;
    }

    public getTypeFromVarEditorList(aName, aDefaultValue, aFromRetCode) {
        let wType;
        wType = this.getVariableType(aName);
        if (BaseType.indexOf(wType) !== -1) {
            wType = this.setType(wType, '', '', '', '', false, '', false);
        } else {
            wType = this.findType(aName, aDefaultValue, aFromRetCode);
        }
        return wType;
    }

    private setType(aType, aOption, aDefault, aPattern, aValue, aEditable, aValueCombo, aDisabled) {
        return {
            type: aType,
            option: aOption,
            default: aDefault,
            pattern: aPattern,
            value: aValue,
            Editable: aEditable,
            valueCombo: aValueCombo,
            disabled: aDisabled,
        };
    }

    private findTypeFromType(aName, aDefaultValue, aFromRetCode) {
        let wType;
        wType = this.execFindType(aName, aDefaultValue, aFromRetCode);
        return wType;
    }

    private findType(aName, aDefaultValue, aFromRetCode) {
        let wType;
        let wEditorName = '';
        wEditorName = this.getVariableType(aName);
        wType = this.execFindType(wEditorName, aDefaultValue, aFromRetCode);
        return wType;
    }

    private execFindType(aName, aDefaultValue, aFromRetCode) {
        let wType;
        wType = this.variableListService.getTypeFromCustomEditorList(aName);
        switch (wType) {
            case 'ListDB':
            case 'ListGroups':
            case 'ListUsers':
            case 'Combo':
            case 'ComboCustom': {
                wType = this.getCombo_value(aFromRetCode, aDefaultValue, aName, wType);
                break;
            }
            // Index dynamique coté ged : considéré uniquement comme une combo, pas d'affichage des index associés
            // on force donc le type en ComboCustom
            case 'DynamicIndex': {
                wType = this.getCombo_value(aFromRetCode, aDefaultValue, aName, wType);
                wType.type = 'ComboCustom';
                break;
            }
            case 'EditMask': {
                wType = this.setType(
                    'EditMask',
                    '',
                    aDefaultValue,
                    this.variableListService.getPattern(aName),
                    aDefaultValue,
                    false,
                    '',
                    false
                );
                break;
            }
            default: {
                wType = this.setType('String', '', aDefaultValue, '', aDefaultValue, false, '', false);
                break;
            }
        }
        return wType;
    }

    private getCombo_value(aFromRetCode, aDefaultValue, aEditorName, aType) {
        let wType;
        let wRes;
        let wDefault: any;
        let wEditable = false;
        let wDisabled = false;
        let wValue = this.initValue();
        let wValueCombo: any;
        wRes = this.variableListService.getOptionComboValue(aEditorName);
        if (aFromRetCode === true) {
            wDefault = this.getComboValueKey(aDefaultValue, wRes.option, 'retCode');
        } else {
            wDefault = this.variableListService.getComboValue(wRes.type, aDefaultValue, wRes.option);
        }
        wEditable = wRes.Editable;
        if (aType === 'ListDB') {
            wEditable = this.variableListService.getEditableComboDb(aEditorName);
        }
        if (aDefaultValue !== '') {
            wValue.displayValue = wDefault.displayValue;
            wValue.retCode = wDefault.retCode;
            wValueCombo = wDefault.retCode;
        } else {
            wValue = {
                displayValue: '',
                retCode: '',
            };
            wValueCombo = '';
        }
        wType = this.setType(wRes.type, wRes.option, wDefault, '', wValue, wEditable, wValueCombo, wDisabled);
        return wType;
    }

    private getValueFromTyp(aData) {
        let wResult;
        const type = {
            ListUsers: this.getValueFromCombo_value,
            ListGroups: this.getValueFromCombo_value,
            ListDB: this.getValueFromCombo_value,
            ComboCustom: this.getValueFromCombo_value,
            Combo: this.getValueFromCombo_valueEditable,
            default: this.getValue_default,
        };

        if (type[aData.type]) {
            wResult = type[aData.type](aData, this);
        } else {
            wResult = type['default'](aData);
        }
        return wResult;
    }

    private getValueFromCombo_value(aData, self) {
        let wValue = {
            displayValue: '',
            retCode: '',
        };
        if (aData.value) {
            if (aData.multiSelectMode === true) {
                wValue = aData.value;
            } else {
                wValue = {
                    displayValue: aData.value.displayValue,
                    retCode: aData.value.retCode,
                };
            }
        }
        return wValue;
    }

    private getValueFromCombo_valueEditable(aData, self) {
        let wValue: any;
        if (aData.Editable === true) {
            wValue = '';
            if (aData.valueCombo.retCode) {
                wValue = aData.valueCombo.retCode;
            } else {
                wValue = aData.valueCombo;
            }
        } else {
            wValue = self.getValueFromCombo_value(aData, self);
        }
        return wValue;
    }

    private getValue_default(aData) {
        let wValue = '';
        if (aData.value) {
            wValue = aData.value;
        }
        return wValue;
    }

    public getVariableValue(aVarList, aName) {
        let wRes: any;
        let wValue = '';
        const normalizedName = aName.toUpperCase();
        for (const item of aVarList) {
            if (item.name.toUpperCase() === normalizedName) {
                wRes = item;
                break;
            }
        }
        if (wRes) {
            wValue = this.getValueFromType(wRes, true);
        }
        return wValue;
    }

    public getValueFromType(aVariable, aRequest) {
        const type = {
            EditMask: this.getMask,
            DynamicIndex: this.getDynIndex,
            DateTime: this.getDate,
            Date: this.getDate,
            Double: this.getNumber,
            Integer: this.getInteger,
            String: this.getString,
            TextArea: this.getString,
            Boolean: this.getBoolean,
            Combo: this.getCombo,
            ListUsers: this.getCustomCombo,
            ListGroups: this.getCustomCombo,
            ListDB: this.getCustomComboDB,
            ComboCustom: this.getCustomCombo,
            default: this.getDefault,
        };
        if (aVariable.multiSelectMode === true) {
            return this.getMultiSelect(aVariable);
        }
        else {
            if (['ListUsers', 'ListGroups', 'ListDB', 'ComboCustom'].indexOf(aVariable.type) > -1) {
                return type[aVariable.type](aVariable, aRequest);
            }
            if (type[aVariable.type]) {
                return type[aVariable.type](aVariable);
            } else {
                return type['default'](aVariable);
            }
        }
    }

    private getDefault(aVariable) {
        return '';
    }

    private getDynIndex(aVariable) {
        let wValue = '';
        if (aVariable.value.retCode) {
            wValue = returnEmpty(aVariable.value.retCode);
        }
        return wValue;
    }

    private getMultiSelect(aVariable) {
        let wValue = '';
        for (let i = 0; i < aVariable.value.length; i++) {
            wValue += aVariable.value[i].retCode + ',';
        }
        wValue = truncString(wValue, 1);
        return wValue;
    }

    private getNumber(aVariable) {
        let wValue = '';
        wValue = returnEmpty(aVariable.value);
        wValue = wValue.replace(/\s/g, '');
        return wValue;
    }

    private getInteger(aVariable) {
        let wValue = '';
        wValue = returnEmpty(aVariable.value);
        return wValue;
    }

    private getMask(aVariable) {
        let wValue = '';
        wValue = returnEmpty(aVariable.value);
        if (wValue !== '') {
            wValue = encodeUtf8(aVariable.value);
        }
        return wValue;
    }

    private getDate(aVariable) {
        let wValue = '';
        wValue = returnEmpty(aVariable.value);
        if (wValue !== '') {
            wValue = formatDateInt(aVariable.value, false); // ok pour requete
        }
        return wValue;
    }
    private getString(aVariable) {
        let wValue = '';
        wValue = returnEmpty(aVariable.value);        
        if (wValue !== '') {
            wValue = aVariable.value;
        }
        return wValue;
    }

    private getBoolean(aVariable) {
        let wValue = '';
        switch (aVariable.value) {
            case true:
                wValue = 'true';
                break;
            case false:
                wValue = 'false';
                break;
            default:
                wValue = '';
                break;
        }
        return wValue;
    }

    private getCombo(aVariable) {
        let wValue = '';
        if (aVariable.Editable === false) {
            if (aVariable.value) {
                wValue = returnEmpty(aVariable.value.retCode);
            }
        } else {
            if (aVariable.valueCombo) {
                if (aVariable.valueCombo.retCode !== undefined) {
                    wValue = returnEmpty(aVariable.valueCombo.retCode);
                } else {
                    wValue = returnEmpty(aVariable.valueCombo);
                }
            }
        }
        return wValue;
    }

    private getCustomCombo(aVariable, aRequest) {
        let wValue = '';
        if (aVariable.value) {
            if (aRequest) {
                wValue = returnEmpty(aVariable.value.retCode);
            } else {
                wValue = returnEmpty(aVariable.value.displayValue);
            }
        }
        return wValue;
    }

    private getCustomComboDB(aVariable, aRequest) {           
        let wValue = '';                                                                                                                               
        if (aRequest) {
            if (aVariable.Editable === false) {                                                                                                        
                wValue = returnEmpty(aVariable.value.retCode);
            } else {                                                                                                                                   
                const wSearch = typeof aVariable.value === 'string'
                    ? aVariable.value                                                                                                                  
                    : aVariable.value?.displayValue ?? '';    
                const wFound = aVariable.comboValue?.find(                                                                                             
                    c => c.displayValue === wSearch
                );                                                                                                                                     
                if (wFound) {                                 
                    wValue = returnEmpty(wFound.retCode);
                } else {                                                                                                                               
                    wValue = returnEmpty(wSearch);
                }                                                                                                                                      
            }                                                 
        } else {
            wValue = returnEmpty(aVariable.value.displayValue);                                                                                        
        }
        return wValue;                                                                                                                                 
    }           

    public editorExist(aName: any) {
        let wResult = false;
        const normalizedName = aName.toUpperCase();
        this.getLocalStorage();
        if (verifyCustomEditorList(this.customEditorList) === true) {
            for (const item of this.customEditorList.CustomEditor) {
                if (item.Information.Name.toUpperCase() === normalizedName) {
                    wResult = true;
                    break;
                }
            }
        }
        return wResult;
    }

    public getValue(adata, aValue) {
        let wRes: any;
        wRes = undefined;
        for (let i = 0; i < adata.show.length; i++) {
            if (adata.value[i] === aValue) {
                wRes = new Object();
                wRes = {
                    show: adata.show[i],
                    value: adata.value[i],
                };
                break;
            }
        }
        return wRes;
    }

    public addToComboValue(aSrcCombo, adata) {
        let wCombo: any;
        wCombo = new Object();
        wCombo = {
            displayValue: adata.show,
            retCode: adata.value,
        };
        aSrcCombo.push(wCombo);
        return aSrcCombo;
    }

    public getOptionComboValueData(aName: any) {
        let wResult: any;
        wResult = this.variableListService.getOptionComboValueData(aName);
        return wResult;
    }

    private getVariableType(aName) {
        let wType = 'String';
        const normalizedName = aName.toUpperCase();
        this.getLocalStorage();
        if (this.variableStorage.length !== 0) {
            for (const item of this.variableStorage.Variable) {
                if (item.Name.toUpperCase() === normalizedName) {
                    wType = item.Type;
                    break;
                }
            }
        }
        return wType;
    }
}
